// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface DataType {
  delivery_no: number
  invoice_id: number
  sales_order_id: number
  trx_code: string
  total_payment:number
}
type Type = DataType | null

export function useInvoiceDetail(): {
  data: Type
  fetchData: (invoice_id: number) => void
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type>(null)
  const [isLoading, setLoading] = useState<boolean>(false)

  // Functions
  const fetchData = (invoice_id: number) => {
    setLoading(true)

    api.get(
      "/invoice/detailinvoice",
      { params: { invoice_id } }
    ).then((res: SuccessFetch<{
      payload: { datainvoice: DataType }
    }>) => {
      setData(res.data.payload.datainvoice)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, fetchData }
}